/**
   * Get item from local storage by given key
   * @param {String} key item key
   * @param {String} defaultValue default value
   */
export const getKey = (key, defaultValue = '') => {
  var obj = JSON.parse(window.localStorage.getItem(key) || '{}')
  return typeof (obj) === 'object' ? (Object.keys(obj).length > 0 ? obj : defaultValue) : obj
}

/**
   * Add item to local storage by given key and value
   * @param {String} key item key
   * @param {Object} value item data
   */
export const saveKey = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value))
}

/**
   * Remove item from local storage by given key
   * @param {String} key item key
   */
export const removeKey = (key) => {
  window.localStorage.removeItem(key)
}

/**
   * Get tag navigation list from local storage
   *
   * @returns {Array} list of router
   */
export const getTagNavListFromLocalstorage = () => {
  const list = localStorage.tagNaveList
  return list ? JSON.parse(list) : []
}

/**
   * @description Store tag navigation list in local storage
   */
export const setTagNavListInLocalstorage = list => {
  localStorage.tagNaveList = JSON.stringify(list)
}
